import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=6946f5fd"
import script from "./IndexLayout.vue?vue&type=script&lang=js"
export * from "./IndexLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports